import { ChangeDetectionStrategy, Component, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'app-style-boundary',
  standalone: true,
  imports: [],
  template: `
    <div class="style-boundary">
      <ng-content></ng-content>
    </div>
  `,
  styleUrl: './style-boundary.component.scss',
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class StyleBoundaryComponent {}
